import { render, staticRenderFns } from "./BenchmarkBarChart.vue?vue&type=template&id=6b47621c&scoped=true&"
import script from "./BenchmarkBarChart.vue?vue&type=script&lang=js&"
export * from "./BenchmarkBarChart.vue?vue&type=script&lang=js&"
import style0 from "./BenchmarkBarChart.vue?vue&type=style&index=0&id=6b47621c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b47621c",
  null
  
)

export default component.exports